import React from 'react';
import Input from '../Input';

function SubscribeEmailAddress({ size, state, errors, onChange }) {
  return (
    <Input type="text" autoComplete="email" className={`subscribe-${size}-input-email`} error={errors.email} name="email" label="Email Address" placeholder="username@example.com" value={state.email} onChange={onChange} />
  );
}

export default SubscribeEmailAddress;
